import {WhitelabelStyles} from "../whitelabel-service.domain";

export type WhitelabelStylesValue = WhitelabelStyles | null;
